// src/services/webrtc.js
import Peer from 'peerjs';

class WebRTCService {
  constructor() {
    this.peer = null;
    this.currentCall = null;
    this.localStream = null;
    this.remoteStream = null;
    this.currentUserId = null;
    this.onCallReceived = null;
    this.onRemoteStream = null;
    this.myPeerId = null;
  }

  init(userId, callbacks) {
    this.currentUserId = userId;
    this.onCallReceived = callbacks.onCallReceived;
    this.onRemoteStream = callbacks.onRemoteStream;

    // ✅ Génération d'un ID unique (avec timestamp)
    const peerId = `user_${userId}_${Date.now()}`;
    console.log("🚀 Initialisation PeerJS avec ID:", peerId);

    this.peer = new Peer(peerId, {
      host: '0.peerjs.com',
      port: 443,
      secure: true,
      debug: 2,
      config: {
        iceServers: [
          { urls: 'stun:stun.l.google.com:19302' },
          { urls: 'stun:stun1.l.google.com:19302' },
          {
            urls: 'turn:openrelay.metered.ca:80',
            username: 'openrelayproject',
            credential: 'openrelayproject'
          }
        ]
      }
    });

    this.peer.on('open', (id) => {
      console.log('✅ PeerJS connecté, ID:', id);
      this.myPeerId = id;
      // ✅ Sauvegarde dans la base
      fetch('/api/ajax/save-peer-id.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, peer_id: id })
      }).catch(err => console.error('Erreur sauvegarde peer id:', err));
    });

    this.peer.on('call', (call) => {
      console.log('📞 Appel entrant de', call.peer);
      if (this.onCallReceived) this.onCallReceived(call);
    });

    this.peer.on('error', (err) => {
      console.error('❌ PeerJS error:', err);
    });
  }

  async startCall(targetPeerId) {
    console.log("📞 startCall vers", targetPeerId);
    if (!this.myPeerId) throw new Error('Peer non encore initialisé');
    try {
      this.localStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      console.log("🎥 Flux local obtenu");
      const call = this.peer.call(targetPeerId, this.localStream);
      this.currentCall = call;

      call.on('stream', (remoteStream) => {
        console.log('✅ Stream distant reçu');
        this.remoteStream = remoteStream;
        if (this.onRemoteStream) this.onRemoteStream(remoteStream);
      });

      call.on('close', () => this.endCall());
      call.on('error', (err) => console.error('Call error:', err));

      return this.localStream;
    } catch (err) {
      console.error("❌ Erreur startCall:", err);
      throw err;
    }
  }

  async answerCall(call) {
    try {
      this.localStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      call.answer(this.localStream);
      this.currentCall = call;

      call.on('stream', (remoteStream) => {
        console.log('✅ Stream distant reçu');
        this.remoteStream = remoteStream;
        if (this.onRemoteStream) this.onRemoteStream(remoteStream);
      });

      call.on('close', () => this.endCall());
      return this.localStream;
    } catch (err) {
      console.error("❌ Erreur answerCall:", err);
      throw err;
    }
  }

  endCall() {
    if (this.currentCall) this.currentCall.close();
    if (this.localStream) this.localStream.getTracks().forEach(track => track.stop());
    this.localStream = null;
    this.remoteStream = null;
  }

  getPeerId() {
    return this.myPeerId;
  }

  destroy() {
    this.endCall();
    if (this.peer) this.peer.destroy();
  }
}

export default new WebRTCService();